import { some } from 'lodash';

import { SaleModel } from '@shared/app/scripts/classes/sale-model';

/*
 * Service isReturn
 */
angular.module('posApp').factory('isReturn', () => {
  const isReturn = (transaction: SaleModel) => {
    if (!transaction || !transaction?.receipt) {
      return false;
    }

    return some(transaction.receipt, (row) => {
      return row.category === 'barcode' && row.qty < 0;
    });
  };

  return isReturn;
});
